<template>
  <div class="ecReceiveorderCom">
    <v-data-table
      :headers="headersTmp"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      :no-data-text="$t('common.common_not-register')"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td :colspan="headersTmp.length" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>

          <tr v-for="(item, trIndex) in items" :key="`group-${trIndex}`">
            <template v-for="(header, index) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none'
                }"
                :key="index"
              >
                <slot :name="header.value" v-bind:item="item">
                  <div v-if="isName(header, 'receiveOrderDate')">
                    {{ getDate(item.receiveOrderDate) }}
                  </div>
                  <div v-else-if="isName(header, 'receiveOrderTotalAmount')">
                    {{ formatPrice(item.receiveOrderTotalAmount) }}
                  </div>
                  <div v-else-if="isName(header, 'detail')">
                    <v-layout justify-center>
                      <WhiteButton
                        text="common.common_detail"
                        height="32px"
                        width="32px"
                        class="mx-1"
                        @click="detail(item)"
                      />
                    </v-layout>
                  </div>
                  <div v-else-if="isName(header, 'saleStatus')">
                    {{ getSaleStatusName(item.saleStatus) }}
                  </div>
                  <div v-else>
                    {{ getDefaultValue(item, header) }}
                  </div>
                </slot>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { currencyUtil, consumptionTaxUtil, commonUtil } from '@/util'
import { mapActions, mapGetters } from 'vuex'
import { NormalButton, WhiteButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'EcReceiveorderTable',

  components: {
    WhiteButton,
    NormalButton
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    headers: [],
    items: [],
    itemKey: String,
    search: { default: '' },
    productKey: String
  },
  data: () => ({
    itemsDetail: [],
    headersTmp: [],
    detailEcReceiveorderData: {},
  }),
  created() {
    this.createHeaders()
  },
  methods: {
    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          currencyIdName:
            'currencyIdName' in header ? header.currencyIdName : '',
          align: 'align' in header ? header.align : ''
        }
      })
      this.headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
    },
    // 日付フォーマットをyyyy/M/dに変換
    getDate(date) {
      const [year, month, day] = date.split(' ')[0].split('-')
      return `${year}/${Number(month)}/${Number(day)}`
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getSaleStatusName(status) {
      // ステータス「3」の場合の表示を追加
      if (status === 1 || status === 2) {
        return this.$t('nextengine.nextengine_ec-receiveorder-status-registerd')
      }
      if (status === 3) {
        return this.$t('nextengine.nextengine_ec-receiveorder-status-pending')
      }
      return this.$t(
        'nextengine.nextengine_ec-receiveorder-status-not-registerd'
      )
    },
    getTaxValue(id) {
      return consumptionTaxUtil.getConsumptionTaxIdInfo(id)
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    // 詳細ボタンクリック時の処理
    async detail(ecReceiveorderData) {
      this.detailEcReceiveorderData = await _cloneDeep(ecReceiveorderData)
      this.$emit('detail', this.detailEcReceiveorderData)
    },
  }
}
</script>
<style lang="scss" scoped>
.ecReceiveorderCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .DisplayNone {
    display: none;
  }
  .exportSubjectFlg {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
